<template>
  <MobileContainer :class="$style.host">
    <MobileHeader slot="header"
                  :class="$style.header"
    >
      Guest Checkout
    </MobileHeader>

    <img :class="$style.mainLogo"
         srcset="@/assets/img/LOGO@2x.png, @/assets/img/LOGO.png"
         src="@/assets/img/LOGO.png"
         alt="Burger Boss">

    <GuestCheckoutModal :class="$style.checkoutForm"
                        @continue="checkout"
                        @create-account="handleCreateAccount"
                        @sign-in="handleSignIn"
    />
  </MobileContainer>
</template>

<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import MobileContainer from '@/apps/mobile/components/MobileContainer';
import MobileButton from '@/apps/mobile/components/MobileButton';
import MobileHeader from '@/apps/mobile/components/MobileHeader';
import GuestCheckoutModal from '@/components/GuestCheckoutModal';
import { Action, Getter } from 'vuex-class';
import { CART_COLLAPSE, CART_PREPARE_ORDER } from '@/apps/cart/store/types';
import LoadingMixin from '@/lib/mixins/loading-mixin';

@Component({
  components: {
    GuestCheckoutModal,
    MobileHeader,
    MobileButton,
    MobileContainer,
  },
  mixins: [
    LoadingMixin,
  ],
})
export default class GuestCheckout extends Vue  {
  @Getter orderType;
  @Getter restaurantId;
  @Action(CART_COLLAPSE) cartCollapse;
  @Action(CART_PREPARE_ORDER) prepareOrder;

  /**
   * Provide cart data preparation for order creation on backend.
   * @param userData
   */
  async checkout(userData) {
    if (!this.orderType) {
      this.$router.push({ name: 'mobile-main' });
    } else if (!this.restaurantId) {
      this.$router.push({ name: 'new-order-select-location' });
    } else {
      try {
        this.loadingStart();
        await this.prepareOrder({ userData });
        this.$router.push({ name: 'payment-confirm' });
      } catch (e) {
        this.$router.push({ name: 'menu' });
      } finally {
        this.cartCollapse();
        this.loadingStop();
      }
    }
  }
  /**
   * Event handler for "createAccount"
   */
  handleCreateAccount() {
    this.$router.push({ name: 'join-sign-in' });
  }


  /**
   * Event handler for "signIn"
   */
  handleSignIn() {
    this.$router.push({ name: 'claim-account' });
  }

  /**
   * Event handler for "guestCheckout"
   */
  handleGuestCheckout() {
    this.$router.push({ name: 'guest-checkout' });
  }
}
</script>

<style lang="scss" module>

.host {
  padding-top: 20px;
}

.header {
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  right: 0;
}

.mainLogo {
  display: block;
  height: 169px;
  width: 169px;
  margin: 57px auto 54px;
}

.checkoutForm {
  padding-bottom: 70px;
}
</style>



// WEBPACK FOOTER //
// src/apps/mobile/components/GuestCheckout.vue